var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form_submit" }, [
        _c("div", { staticClass: "action_area" }, [
          _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.goTop } },
            [_vm._v("TOPへ戻る")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_main" }, [
      _c("h1", [_vm._v("アップロード完了")]),
      _vm._v(" "),
      _c("section", { staticClass: "confirm_sec" }, [
        _c("p", [
          _vm._v("\n        スケッチアップロードが完了いたしました。"),
          _c("br"),
          _vm._v(
            "\n        プランニング担当者からご連絡いたしますので、お待ちください。\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-711962a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-711962a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/UploadComplete.vue
// module id = null
// module chunks = 